export const BackgroundTimer = {
  start: (callback: () => void, delay: number) => {
    return setTimeout(callback, delay)
  },
  stop: (timer: any) => {
    clearTimeout(timer)
  },
  setTimeout: (callback: () => void, delay: number) => {
    return setTimeout(callback, delay)
  },
  clearTimeout: (timer: any) => {
    clearTimeout(timer)
  },
  setInterval: (callback: () => void, delay: number) => {
    return setInterval(callback, delay)
  },
  clearInterval: (timer: any) => {
    clearInterval(timer)
  },
}

export default BackgroundTimer
